import { render, staticRenderFns } from "./orderReceived.vue?vue&type=template&id=16188e0a&scoped=true&"
import script from "./orderReceived.vue?vue&type=script&lang=js&"
export * from "./orderReceived.vue?vue&type=script&lang=js&"
import style0 from "./orderReceived.vue?vue&type=style&index=0&id=16188e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16188e0a",
  null
  
)

export default component.exports